import CloseIcon from "@mui/icons-material/Close";
import InputAdornment from "@mui/material/InputAdornment";
import { FlexColumn, GridRow, IconButton, OverflowText, TextField } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import { white } from "designSystem/styles/color";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { CompositionMaterial, useCompositionStore } from "./CompositionStore";

interface CompositionWithoutSustainabilitySingleItemProps {
	item: CompositionMaterial;
}
const CompositionWithoutSustainabilitySingleItem: FunctionComponent<CompositionWithoutSustainabilitySingleItemProps> = observer(function CompositionWithoutSustainabilitySingleItem(props) {
	const {
		item,
	} = props;
	const {
		noSustainPercentageFixed,
		compositionKey,
		compositionMaterialPercentageIsInvalid,
		compositionNode,
		setCompositionMaterialPercentage,
	} = item;
	const { removeComposition } = useCompositionStore();
	const loc = useLocale();
	const name = loc.getNodeName(compositionNode);

	return (
		<FlexColumn
			bgcolor={white[50]}
			borderRadius="3px"
			flexGrow={1}
			gap={3}
			marginBottom={3}
			padding={2}
		>
			<GridRow
				alignItems="center"
				flexWrap="nowrap"
				growChild={0}
			>
				<OverflowText bold text={name} />
				<IconButton onClick={() => removeComposition(compositionKey)} size="small">
					<CloseIcon />
				</IconButton>
			</GridRow>
			<TextField
				InputProps={{
					endAdornment:
						<InputAdornment position="end">
							{loc.resource("PercentageSign")}
						</InputAdornment>,
				}}
				defaultValue={noSustainPercentageFixed}
				error={compositionMaterialPercentageIsInvalid}
				onChange={setCompositionMaterialPercentage}
				placeholderRes="FormatDoublePercentage"
				required
				selectOnFocus
				type="text"
			/>
		</FlexColumn>
	);
});

export default CompositionWithoutSustainabilitySingleItem;